<section class="contact-header">
	@if (canEdit() && showEdit()) {
		<div>
			{{ editabilityMessage() }}
			<mat-icon>edit</mat-icon>
		</div>
	}
</section>
<table
	[class]="{ 'bottom-border': hasBottomBorder() }"
	[attr.aria-label]="('base.field.contact' | transloco) + ' Id ' + contact().id"
>
	<thead>
		<tr>
			<th scope="col">{{ 'base.field.contact_date' | transloco }}</th>
			<th scope="col">{{ 'base.field.contact_type' | transloco }}</th>
			<th scope="col">{{ 'base.field.keyword' | transloco }}</th>
			<th scope="col">{{ 'base.field.with_client' | transloco }}</th>
			<th scope="col">{{ 'base.field.confidential' | transloco }}</th>
			@if (showRemarks()) {
				<th scope="col">{{ 'base.field.remark' | transloco }}</th>
			}
			<th scope="col">{{ 'base.field.participants' | transloco }}</th>
			@if (showDocuments()) {
				<th scope="col">{{ 'base.field.documents' | transloco }}</th>
			}
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>{{ contact().contactedAt | date: dateDisplayFormat }}</td>
			<td>{{ contact().contactType.remark }}</td>
			<td>
				<div class="line-clamp">
					{{ contact().keyword }}
				</div>
			</td>
			<td>
				<div class="line-clamp">
					{{
						contact().clientParticipated
							? ('base.field.with_client_true' | transloco)
							: ('base.field.with_client_false' | transloco)
					}}
				</div>
			</td>
			<td>
				{{
					contact().confidential
						? ('base.field.with_client_true' | transloco)
						: ('base.field.with_client_false' | transloco)
				}}
			</td>
			@if (showRemarks()) {
				<td>
					<div class="line-clamp">
						{{ contact().remark }}
					</div>
				</td>
			}
			<td>{{ contact().participantsCount }}</td>
			@if (showDocuments()) {
				<td>
					<ul>
						@for (doc of contact().documents; track doc.id) {
							<li class="truncate">
								{{ doc.name }}
							</li>
						}
					</ul>
				</td>
			}
		</tr>
	</tbody>
</table>
